import { createFileRoute } from '@tanstack/react-router';
import { AddGiftCardPage } from '@/features/gift-cards/add-flow/add-gift-card-page';
import { GiftCardsRouteError } from '@/features/gift-cards/error/gift-cards-route-error';

interface AddGiftCardSearch {
	/** 'native_payment' switches to the bridge result path (contracts §3.1). */
	src?: string;
}

// Behind `_auth`, like the listing. This route *writes* — recharge-wallet
// consumes a voucher against the caller's session — so anonymously it can only
// fail, and it would fail after the user had typed a real gift-card number in.
// The public URL is unchanged (`_auth` is pathless), so the native webview entry
// in the add-flow contracts §3.1 still works. Client bootstrap synchronizes
// native app data/auth before this gate; existing `pwa/initialpage` cookies
// remain the fallback for older app builds.
export const Route = createFileRoute('/_auth/ixi-finance/gift-cards_/add')({
	validateSearch: (search: Record<string, unknown>): AddGiftCardSearch => ({
		src: typeof search.src === 'string' ? search.src : undefined,
	}),
	component: AddGiftCardPage,
	errorComponent: GiftCardsRouteError,
	ssr: false,
});
